export const nonNullable = <T>(value: T): NonNullable<T> => {
  if (value === undefined || value === null) {
    throw new Error("Value is required and cannot be undefined or null.");
  }
  return value;
};
